export default {
  state: {
    actionButtons: true,
    imageUploading: false,
    diableDistributor: false,
    productSaving: false,
    removeVariant: false
  },

  mutations: {
    setActionButtonsStatus (state, payload) {
      state.actionButtons = payload
    },
    setImageUploadingStatus (state, payload) {
      state.imageUploading = payload
    },
    setDistributorStatus (state, payload) {
      state.diableDistributor = payload
    },
    setProductSaving (state, payload) {
      state.productSaving = payload
    },
    setRemoveVariant (state, payload) {
      state.removeVariant = payload
    }
  },

  actions: {
    setCampaignActionButtonsStatus ({commit}, payload) {
      commit('setActionButtonsStatus', payload)
    },
    setUploadingStatus ({commit}, payload) {
      commit('setImageUploadingStatus', payload)
    },
    setCampaignDistributorStatus ({commit}, payload) {
      commit('setDistributorStatus', payload)
    },
    setCampaignProductSaving ({commit}, payload) {
      commit('setProductSaving', payload)
    },
    setCampaignRemoveVariant ({commit}, payload) {
      commit('setRemoveVariant', payload)
    }
  },

  getters: {
    getEditProductStatus (state) {
      return state.actionButtons
    },
    getImageUploadingStatus (state) {
      return state.imageUploading
    },
    getDistributorStatus (state) {
      return state.diableDistributor
    },
    getProductSaving (state) {
      return state.productSaving
    },
    getRemoveVariant (state) {
      return state.removeVariant
    }
  }
}
